import React from 'react'
import Player from "@madzadev/audio-player";


import './Reproductor.scss';

const Reproductor = () => {
    const colors = `html {
        --tagsBackground: #9440f3;
        --tagsText: #ffffff;
        --tagsBackgroundHoverActive: #2cc0a0;
        --tagsTextHoverActive: #ffffff;
        --searchBackground: #18191f;
        --searchText: #ffffff;
        --searchPlaceHolder: #575a77;
        --playerBackground: #18191f;
        --titleColor: #ffffff; 
        --timeColor: #ffffff;
        --progressSlider: #9440f3;
        --progressUsed: #ffffff;
        --progressLeft: #151616;
        --volumeSlider: #9440f3;
        --volumeUsed: #ffffff;
        --volumeLeft:  #151616;
        --playlistBackground: #181f1b;
        --playlistText: #575a77;
        --playlistBackgroundHoverActive:  #18191f;
        --playlistTextHoverActive: #ffffff;
    }`;

    const tracks = [
        {
            url: "../../audios/pista1.mp3",
            title: "01-Página 28",
            tags: ["house"],
        },
        {
            url: "../../audios/pista2.mp3",
            title: "02-Página 31",
            tags: ["dnb"],
        },
        {
            url: "../../audios/pista3.mp3",
            title: "03-Página 34",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista4.mp3",
            title: "04-Página 37",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista5.mp3",
            title: "05-Página 40",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista6.mp3",
            title: "06-Página 42",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista7.mp3",
            title: "07-Página 45",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista8.mp3",
            title: "08-Página 49",
            tags: ["house"],
        },
        {
            url: "../../audios/pista9.mp3",
            title: "09-Página 52",
            tags: ["dnb"],
        },
        {
            url: "../../audios/pista10.mp3",
            title: "10-Página 55",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista11.mp3",
            title: "11-Página 68",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista12.mp3",
            title: "12-Página 71",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista13.mp3",
            title: "13-Página 74",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista14.mp3",
            title: "14-Página 78",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista15.mp3",
            title: "15-Página 80",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista16.mp3",
            title: "16-Página 83",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista17.mp3",
            title: "17-Página 86",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista18.mp3",
            title: "18-Página 92",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista19.mp3",
            title: "19-Página 94",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista20.mp3",
            title: "20-Página 97",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista21.mp3",
            title: "21-Página 100",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista22.mp3",
            title: "22-Página 102",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista23.mp3",
            title: "23-Página 105",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista24.mp3",
            title: "24-Página 108",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista25.mp3",
            title: "25-Página 111",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista26.mp3",
            title: "26-Página 114",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista27.mp3",
            title: "27-Página 117",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista28.mp3",
            title: "28-Página 119",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista29.mp3",
            title: "29-Página 121",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista30.mp3",
            title: "30-Página 124",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista31.mp3",
            title: "31-Página 135",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista32.mp3",
            title: "32-Página 143",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista33.mp3",
            title: "33-Página 145",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista34.mp3",
            title: "34-Página 147",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista35.mp3",
            title: "35-Página 149",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista36.mp3",
            title: "36-Página 152",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista37.mp3",
            title: "37-Página 164",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista38.mp3",
            title: "38-Página 166",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista39.mp3",
            title: "39-Página 167",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista40.mp3",
            title: "40-Página 169",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista41.mp3",
            title: "41-Página 170",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista42.mp3",
            title: "42-Página 171",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista43.mp3",
            title: "43-Página 172",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista44.mp3",
            title: "44-Página 173",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista45.mp3",
            title: "45-Página 176",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista46.mp3",
            title: "46-Página 178",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista47.mp3",
            title: "47-Página 180",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista48.mp3",
            title: "48-Página 182",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista49.mp3",
            title: "49-Página 184",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista50.mp3",
            title: "50-Página 187",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista51.mp3",
            title: "51-Página 189",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista52.mp3",
            title: "52-Página 191",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista53.mp3",
            title: "53-Página 193",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista54.mp3",
            title: "54-Página 195",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista55.mp3",
            title: "55-Página 197",
            tags: ["dubstep"],
        },
        {
            url: "../../audios/pista56.mp3",
            title: "56-Página 199",
            tags: ["dubstep"],
        }
    ];

    return (
        <Player 
            trackList={tracks}
            includeTags={false}
            ncludeSearch={true}
            showPlaylist={true}
            autoPlayNextTrack={true}
            customColorScheme={colors}
        />
    )
}

export default Reproductor